export default __webpack_public_path__ + "static/media/itemArrow.3dc68b08.svg";